export default __webpack_public_path__ + "a3d004a.png";